<template>
  <div id="app">
    <img src="/static/svg/icon_lock_x1.svg" class="pre-image-no-show" />
    <img src="/static/svg/icon_share.svg" class="pre-image-no-show" />
    <img src="/static/svg/icon_Rename.svg" class="pre-image-no-show" />
    <img src="/static/svg/icon_Delete.svg" class="pre-image-no-show" />
    <img src="/static/svg/icon_BlockView.svg" class="pre-image-no-show" />
    <img src="/static/svg/icon_ListView.svg" class="pre-image-no-show" />
    <img src="/static/svg/icon_folder.svg" class="pre-image-no-show" />
    <img src="/static/svg/icon_Upload.svg" class="pre-image-no-show" />
    <img src="/static/svg/icon_nav_x1.svg" class="pre-image-no-show" />
    <img src="/static/svg/icon_nav1_x1.svg" class="pre-image-no-show" />
    <img src="/static/svg/icon_dropdown.svg" class="pre-image-no-show" />
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'
Vue.prototype.$EventBus = new Vue()
Vue.component('LoadWaiting', {
  template: `
    <div class="load-waiting">

    </div>
  `
})
export default {
  name: 'App'
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
  border: 0;
}
#app {
  font-family: 'GothamBook', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  min-width: 1000px;
}
.load-waiting{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  /*background: rgba(0,0,0,.01);*/
}
.load-waiting:after {
  content: '';
  display: inline-block;
  background: url(/static/images/loading_gray.png) no-repeat center;
  background-size: contain;
  width: 50px;
  height: 50px;
  position: absolute;
  animation: rotate1 1s linear infinite;
  top: 50%;
  left: 50%;
  margin-top: -25px;
  margin-left: -25px;
}

@keyframes rotate1 {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.ui-box{
  width: 100%;
}
.pre-image-no-show{
  display: none !important;
  width: 0 !important;
  height: 0 !important;
  opacity: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue